import { render, staticRenderFns } from "./InstanceUpdater.vue?vue&type=template&id=3894c759&scoped=true&"
import script from "./InstanceUpdater.vue?vue&type=script&lang=js&"
export * from "./InstanceUpdater.vue?vue&type=script&lang=js&"
import style0 from "./InstanceUpdater.vue?vue&type=style&index=0&id=3894c759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3894c759",
  null
  
)

export default component.exports